{
  "consents": {
    "email": "E-mail",
    "emptyEmailValidator": "E-mail is required",
    "error": "Something went wrong, please try again later.",
    "errorTryAgain": "Try again",
    "invalidEmailValidator": "Type in a valid e-mail",
    "linkText": "If your e-mail address is registered in our systems, an e-mail has been sent to:",
    "send": "Send",
    "submitNewCheck": "New e-mail",
    "thanks": "Thanks!"
  },
  "newsletter": {
    "firstname": "First name",
    "lastname": "Last name",
    "emailAddress": "E-mail",
    "levels": "Level interests",
    "campuses": "Place of study",
    "subjects": "Academic interests",
    "submit": "Send",
    "error": "Something went wrong, please try again later.",
    "consentValidator": "You have to give consent",
    "firstnameValidator": "First name is required",
    "lastnameValidator": "Last name is required",
    "levelValidator": "You have to choose a level interest",
    "mailValidator": "E-mail is required",
    "mailFormatValidator": "Type in a valid e-mail"
  }
}
